import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";

export default function useAuth() {
    const [authInitialized, setAuthInitialized] = useState(false);
    const [user, setUser] = useState();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            if (firebaseUser != null) {
                setAuthInitialized(true);
                setUser(firebaseUser)
            }
            else {
                setAuthInitialized(true)
            }
        });

        return () => unsubscribe();
    }, [auth]);

    return [authInitialized, user];
}
